export const cookieGdprName = 'gdpr';

const calculateExpiryDate = (days: number): string => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  return `expires=${date.toUTCString()}`;
};

const encodeValue = (value: string): string => encodeURIComponent(value);
const decodeValue = (value: string): string => decodeURIComponent(value);

export const setCookie = (name: string, value: string, days: number): void => {
  const expires = calculateExpiryDate(days);
  const encodedValue = encodeValue(value);
  document.cookie = `${name}=${encodedValue}; ${expires}; path=/`;
};

export const getCookie = (name: string): string | null => {
  const nameEQ = `${name}=`;
  const cookie = document.cookie
    .split(';')
    .map(cookie => cookie.trim())
    .find(cookie => cookie.startsWith(nameEQ))
    ?.substring(nameEQ.length);
  return cookie ? decodeValue(cookie) : null;
};

export const deleteCookie = (name: string): void => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
};

// Helper functions for localStorage
export const getLocalStorage = (key: string) => {
  try {
    const value = window.localStorage.getItem(key);

    return value || null;
  } catch {
    return null;
  }
};

export const setLocalStorage = (key: string, value: string) => {
  try {
    if (value) {
      window.localStorage.setItem(key, value);
    }
  } catch {}
};
